import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import NotFoundPage from '../../pages/presentation/demo-pages/helper/NotFoundPage';
import { useLocation } from 'react-router-dom';

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<NotFoundPage />} />
		</Routes>
	);
};

export default ContentRoutes;
